export class Artstamm {
    public idartstamm: number;
    public cartikelnummer: string;
    public artbez1: string;
    public artbez2: string;
    public eancode: string;
}



// WEBPACK FOOTER //
// ./src/providers/rest-server/data/Artstamm.ts